<script setup>

import { useRoute, useRouter } from "vue-router";
import Swal from 'sweetalert2';
import api from '@/api';
import { hasPermission } from "@/composables/useAuth";


import SidenavItem from "./SidenavItem.vue";

const router = useRouter();
const confirmLogout = () => {
  Swal.fire({
    title: '¿Cerrar sesión?',
    text: '¿Estás seguro de que quieres cerrar tu sesión?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, salir',
    cancelButtonText: 'Cancelar',
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (refreshToken) {
          await api.post('/auth/logout', { refreshToken });
        }
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') console.error('Error al cerrar sesión:', e);
      } finally {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        localStorage.removeItem('isLogged');
        router.push('/signin');
        Swal.fire('Sesión cerrada', 'Has cerrado sesión exitosamente', 'success');
      }
    }
  });
};



const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};
</script>
<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li v-if="hasPermission('dashboard.ver')" class="nav-item">
        <sidenav-item to="/dashboard-default" :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          :navText="'Dashboard'">
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li v-if="hasPermission('membresias_catalogo.ver') || hasPermission('socios.ver')" class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6" :class="'ms-2'">
          Sistema
        </h6>
      </li>

      <li v-if="hasPermission('membresias_catalogo.ver') || hasPermission('socios.ver') || hasPermission('config_empresa.gestionar')" class="nav-item dropdown">
        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#submenuAdministrar"
          aria-expanded="false" aria-controls="submenuAdministrar">
          <i class="ni ni-settings-gear-65 text-primary text-sm opacity-10"></i>
          <span class="nav-link-text">Administrar</span>
        </a>
        <ul class="collapse list-unstyled ps-4" id="submenuAdministrar">
         
          <li v-if="hasPermission('membresias_catalogo.ver')">
            <sidenav-item to="/membres" :class="getRoute() === 'membres' ? 'active' : ''" :navText="'Membresías'">
              <template v-slot:icon>
                <i class="ni ni-badge text-info text-sm opacity-10"></i>
              </template>
            </sidenav-item>
          </li>
          <li v-if="hasPermission('membresias_catalogo.ver')">
            <sidenav-item to="/duraciones" :class="getRoute() === 'duraciones' ? 'active' : ''" :navText="'Duraciones'">
              <template v-slot:icon>
                <i class="ni ni-time-alarm text-info text-sm opacity-10"></i>
              </template>
            </sidenav-item>
          </li>
          <li v-if="hasPermission('socios.ver')">
            <sidenav-item to="/users" :class="getRoute() === 'users' ? 'active' : ''" :navText="'Socios'">
              <template v-slot:icon>
                <i class="ni ni-single-02 text-success text-sm opacity-10"></i>
              </template>
            </sidenav-item>
          </li>
          <li v-if="hasPermission('config_empresa.gestionar')">
            <sidenav-item to="/config/empresa" :class="getRoute() === 'config' ? 'active' : ''" :navText="'Empresa'">
              <template v-slot:icon>
                <i class="ni ni-building text-warning text-sm opacity-10"></i>
              </template>
            </sidenav-item>
          </li>
        </ul>
      </li>
      
     <li v-if="hasPermission('asistencias.ver') || hasPermission('pagos.ver')" class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6" :class="'ms-2'">
          Reportes
        </h6>
      </li>

      <li v-if="hasPermission('asistencias.ver') || hasPermission('pagos.ver')" class="nav-item dropdown">
        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#submenuReportes"
          aria-expanded="false" aria-controls="submenuReportes">
          <i class="fa fa-info text-primary text-sm opacity-10"></i>
          <span class="nav-link-text">Información</span>
        </a>
        <ul class="collapse list-unstyled ps-4" id="submenuReportes">
          <li v-if="hasPermission('asistencias.ver')">
            <sidenav-item to="/asistencias" :class="getRoute() === 'asistencias' ? 'active' : ''" :navText="'Asistencias'">
              <template v-slot:icon>
                <i class="ni ni-single-02 text-success text-sm opacity-10"></i>
              </template>
            </sidenav-item>
          </li>
           <li v-if="hasPermission('pagos.ver')">
            <sidenav-item to="/pagos" :class="getRoute() === 'pagos' ? 'active' : ''" :navText="'Pagos Membresías'">
              <template v-slot:icon>
                <i class="fa-solid fa-comment-dollar text-info text-sm opacity-10"></i>
              </template>
            </sidenav-item>
          </li>
        </ul>
      </li>

   

      <li v-if="hasPermission('perfil.propio')" class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6" :class="'ms-2'">
          Cuenta
        </h6>
      </li>

      <li v-if="hasPermission('perfil.propio')" class="nav-item">
        <sidenav-item to="/profile" :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="'Perfil'">
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <a href="#" class="nav-link" @click.prevent="confirmLogout">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-user-run text-danger text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">Cerrar sesión</span>
        </a>
      </li>

      <li class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6" :class="'ms-2'">
          Acceso Público
        </h6>
      </li>

      <li class="nav-item">
        <sidenav-item to="/registrar-acceso" :class="getRoute() === 'registrar-acceso' ? 'active' : ''"
          :navText="'Registrar Asistencia'">
          <template v-slot:icon>
            <i class="ni ni-badge text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <a href="/registrar-acceso" target="_blank" class="nav-link">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-curved-next text-info text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">Abrir en pestaña <i class="fas fa-external-link-alt ms-1 text-xs"></i></span>
        </a>
      </li>

     
    </ul>
  </div>

</template>
